export default [
  {
    title: 'مدیریت بنرها',
    icon: 'bx bx-image',
    children: [
      {
        title: 'بنرهای صفحه اصلی',
        route: { name: 'banner' },
        resource: 'BannerManager',
        action: 'show',
      },
    ],
  },
]
